import "./MentorsWrapper.scss";

import { PageTitle } from "../../components/PageTitle";
import { useOrganizationContext } from "../../contexts/organizations/organizationsContext";
import { MentorPage } from "./MentorPage";

export function MentorsWrapper() {
  const { currentOrganization } = useOrganizationContext();

  return (
    <div className="container-wrapper">
      <div className="d-flex align-items-center no-breadcrumbs">
        <PageTitle pageTitle="Mentors" />
      </div>
      <MentorPage organizationId={currentOrganization?.id || ""} />
    </div>
  );
}
